// Module
var code = "<i ng-if=\"component.tooltip\" class=\"fa fa-question-circle\" ng-class=\"{ 'text-muted': component.type !== 'button' }\" uib-tooltip=\"{{ component.tooltip }}\" tooltip-placement=\"right\" tooltip-popup-close-delay=\"100\" id=\"{{ component.key+'Desc' }}\"></i> ";
// Exports
export default code;